/* unplugin-vue-components disabled */import { render } from "./MyCenter.vue?vue&type=template&id=38c2719c&scoped=true"
import script from "./MyCenter.vue?vue&type=script&lang=js"
export * from "./MyCenter.vue?vue&type=script&lang=js"

import "./MyCenter.vue?vue&type=style&index=0&id=38c2719c&lang=less&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38c2719c"]])

export default __exports__